import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {inject, onMounted, ref} from 'vue'
import type {ButtonInstance} from 'element-plus'
import {
  Document,
  Menu as IconMenu,
  Setting, HomeFilled,
} from '@element-plus/icons-vue'
import R from "@/utils/r";
import SecurityService from "@/api/security";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSider',
  setup(__props) {

const ref1 = ref<ButtonInstance>()
const ref2 = ref<ButtonInstance>()
const open = ref(false)
const changeTour = (current: number) => {
  if (current == 0) {
    router.push('/security');
  } else if (current == 1) {
    router.push('/codebook');
  }
}
const finishTour = () => {
  localStorage.setItem("tour", "1");
}

const securityService = inject('securityService') as SecurityService;

const isCollapse = ref(false)
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

// 在组件挂载后获取数据
onMounted(async () => {
  // 调用服务端接口获取用户数据
  const isShown = localStorage.getItem("tour");
  if (isShown != '1') {
    //则判断密码是否生成，如果没有则加载漫游引导
    securityService.checkLastUsable().then((data: any) => {
      if (R.isSuccess(data)) {
        if (data.t == null) {
          open.value = true;
          router.push('/security');
        }
      }
    });
  }
});


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_tour_step = _resolveComponent("el-tour-step")!
  const _component_el_tour = _resolveComponent("el-tour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_menu, {
      "default-active": "/codebook",
      class: "el-menu-vertical-demo",
      collapse: isCollapse.value,
      onOpen: handleOpen,
      onClose: handleClose,
      router: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/home" }, {
          title: _withCtx(() => [
            _createTextVNode(" 首页 ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(HomeFilled))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, {
          index: "/codebook",
          id: "ref2"
        }, {
          title: _withCtx(() => [
            _createTextVNode(" 账户管理 ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IconMenu))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/file" }, {
          title: _withCtx(() => [
            _createTextVNode(" 内容存储 ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Document))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/logger" }, {
          title: _withCtx(() => [
            _createTextVNode("服务日志")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Document))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, {
          index: "/security",
          id: "ref1"
        }, {
          title: _withCtx(() => [
            _createTextVNode("安全设置")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Setting))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["collapse"]),
    _createVNode(_component_el_tour, {
      modelValue: open.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
      onChange: changeTour,
      onFinish: finishTour
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tour_step, {
          target: "#ref1",
          title: "安全设置",
          placement: "right",
          description: "新注册用户，请先进行安全设置。"
        }),
        _createVNode(_component_el_tour_step, {
          target: "#ref2",
          title: "账户管理",
          placement: "right",
          description: "建立密钥后，即可进行账户管理。"
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})